import { useState } from 'react';
import { Building2, ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { SubsidiaryType } from './subsidiariesData';

interface SubsidiaryCardProps {
  subsidiary: SubsidiaryType;
}

export default function SubsidiaryCard({ subsidiary }: SubsidiaryCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <motion.div
      layout
      className="bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden"
    >
      <div
        className="p-6 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-start gap-4">
          <Building2 className="w-6 h-6 text-brown-600 flex-shrink-0 mt-1" />
          <div className="flex-grow">
            <div className="flex items-center justify-between">
              <h4 className="text-lg font-semibold text-gray-900">
                {subsidiary.name}
              </h4>
              {isExpanded ? (
                <ChevronUp className="w-5 h-5 text-gray-600" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-600" />
              )}
            </div>
            <p className="text-gray-600 mt-1">
              {subsidiary.shortDescription}
            </p>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ 
              opacity: 1, 
              scale: 1,
              transition: {
                type: "spring",
                stiffness: 500,
                damping: 30,
                duration: 0.3
              }
            }}
            exit={{ 
              opacity: 0, 
              scale: 0.95,
              transition: {
                duration: 0.2
              }
            }}
            className="origin-center"
          >
            <div className="px-6 pb-6 border-t border-gray-100 pt-4">
              <p className="text-gray-700 mb-4">
                {subsidiary.description}
              </p>
              {subsidiary.website && (
                <p className="text-gray-600">
                  Website:{' '}
                  <a 
                    href={`https://${subsidiary.website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brown-600 hover:text-brown-700"
                  >
                    {subsidiary.website}
                  </a>
                </p>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}